import LoadFromUserProfiles from "./actions/loadFromActions/LoadFromUserProfiles.js";
import LoadFromSharedProfiles from "./actions/loadFromActions/LoadFromSharedProfiles.js";
import LoadFromVersions from "./actions/loadFromActions/LoadFromVersions.js";
import SaveAsNewVersion from "./actions/SaveAsNewVersion.js";
import SaveToSharedProfiles from "./actions/saveToActions/SaveToSharedProfiles.js";
import SaveToUserProfiles from "./actions/saveToActions/SaveToUserProfiles.js";
import SaveToVersions from "./actions/saveToActions/SaveToVersions.js";
import ResetUserProfiles from "./actions/deleteActions/ResetUserProfiles.js";
import DeleteVersions from "./actions/deleteActions/DeleteVersions.js";
import SimpleReset from "./actions/deleteActions/SimpleReset.js";
export default {
  install(molten) {
    molten.addPlugin('Action', LoadFromUserProfiles);
    molten.addPlugin('Action', LoadFromSharedProfiles);
    molten.addPlugin('Action', LoadFromVersions);
    molten.addPlugin('Action', SaveAsNewVersion);
    molten.addPlugin('Action', SaveToSharedProfiles);
    molten.addPlugin('Action', SaveToUserProfiles);
    molten.addPlugin('Action', SaveToVersions);
    molten.addPlugin('Action', ResetUserProfiles);
    molten.addPlugin('Action', DeleteVersions);
    molten.addPlugin('Action', SimpleReset);
  }
};